import {
  fromCalculationFunctionValueToMechanicType,
  MechanicCreateType,
  MechanicFormValuesType,
} from 'entities/mechanic';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { SubmitHandler } from 'react-hook-form';
import { useAppDispatch } from 'app/store';
import { useCreateMechanicMutation } from 'widgets/mechanic/api/mechanicCreateApi';
import { MechanicForm } from './MechanicForm';

export const CreateMechanicForm = () => {
  const dispatch = useAppDispatch();
  const [creatMechanicRequest] = useCreateMechanicMutation();

  const defaultValues: Partial<MechanicFormValuesType> = {
    name: '',
    description: '',
    steps: [],
    skus: [],
    individual: false,
    is_cycle: false,
  };

  const createMechanicHandler: SubmitHandler<MechanicFormValuesType> = (formData) => {
    const payload: MechanicCreateType = {
      name: formData.name,
      description: formData.description,
      mechanic_type: fromCalculationFunctionValueToMechanicType(formData.calculation_function),
      sku_ids: formData.skus.map((sku) => sku.sku_id),
      steps: formData.steps.map(({ target, reward, reward_type }) => ({
        ...(target !== null && target !== undefined ? { target: Number(target) } : {}),
        ...(reward !== null && reward !== undefined ? { reward: Number(reward) } : {}),
        ...(reward_type ? { reward_type } : {}),
      })),
      is_active: !!formData.is_active,
      is_individual: formData.individual,
      is_cycle: formData.is_cycle,
    };

    creatMechanicRequest({
      app_type: 'admin',
      form: {
        ...payload,
      },
    }).then(() => {
      dispatch(setDrawerOpen(false));
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    });
  };

  return (
    <MechanicForm
      defaultValues={defaultValues}
      onSave={createMechanicHandler}
      mode="create"
    />
  );
};
